function handleScroll() {
    var e = document.getElementsByClassName("support-floating")[0],
        t = document.getElementsByClassName("botaoflutuante")[0], n = document.getElementById("evolution-price-list"),
        o = null;
    t && (o = window.getComputedStyle(t)), e && n && (e.style.bottom = null != o && "block" === o.display ? "65px" : "15px")
}

function increaseValue() {
    var e = parseInt(document.getElementById("number").value, 10);
    e = isNaN(e) ? 0 : e, e++, document.getElementById("number").value = e
}

function decreaseValue() {
    var e = parseInt(document.getElementById("number").value, 10);
    1 !== (e = isNaN(e) ? 0 : e) && e--, document.getElementById("number").value = e
}

function serialize(e) {
    function t(e, n) {
        var o = e.lastIndexOf("[");
        if (-1 === o) {
            var a = {};
            return a[e] = n, a
        }
        var i = e.substr(0, o), r = {};
        return r[e.substring(o + 1, e.length - 1)] = n, t(i, r)
    }

    for (var n = {}, o = 0, a = e.elements.length; o < a; o++) {
        var i = e.elements[o];
        if ("" !== i.name && !i.disabled) if (i.name && !i.disabled && (i.checked || /select|textarea/i.test(i.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(i.type))) n = extend(n, t(i.name, i.value))
    }
    return n
}

function extend() {
    for (var e = {}, t = 0, n = function (t) {
        for (var n in t) t.hasOwnProperty(n) && ("[object Object]" === Object.prototype.toString.call(t[n]) ? e[n] = Form.extend(e[n], t[n]) : e[n] = t[n])
    }; t < arguments.length; t++) n(arguments[t]);
    return e
}

window.onload = function () {
    if (window.matchMedia("(max-width: 768px)").matches) {
        handleScroll(), window.onscroll = handleScroll;
        var e = document.getElementsByClassName("support-floating")[0],
            t = document.getElementsByClassName("botaoflutuante")[0], n = null;
        t && (n = window.getComputedStyle(t)), e && null != n && "block" === n.display && (e.style.bottom = "65px")
    }
}, $(".block-swatch__radio, .variant-swatch__radio, .product-form__single-selector").change((function () {
    setTimeout((function () {
        parcelamento()
    }), 150)
})), $(".options:first-child").addClass("active"), $(".options").each((function () {
    $(this).on("click", (function () {
        $(".options").removeClass("active"), $(this).addClass("active"), $("#evolution-price-list .price-promotional-wrap strong").html($(this).find(".valortot").text()), $("#evolution-price-list .price-promotional-wrap span").html($(this).find(".valorcomp").text()), $("#evolution-price-list .price-promotional-wrap .selector-desconto").remove(), $("#evolution-price-list .price-promotional-wrap").append('<p class="selector-desconto">CUPOM ' + $(this).find(".saving").text() + " APLICADO</p>"), parcelamento()
    }))
})), $(".product-form").each((function () {
    $(this).on("click", ".botaocmprar, .botaoaddcarrinho-qtd", (function (e) {
        e.stopImmediatePropagation();
        const t = "botaoaddcarrinho" === $(this).attr("id") || !window.theme.botaoaddcarrinho, n = [],
            o = parseInt($(".options.active .iddavariante").attr("val")),
            a = parseInt($(".options.active .iddavariante").attr("qtd"));
        n.push({id: o, quantity: a}), $(".buy-together-list input").each((function () {
            !0 === $(this).prop("checked") && n.push({id: $(this).attr("data-id"), quantity: 1})
        }));
        let i = {items: n};
        fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(i),
            credentials: "same-origin",
            method: "POST",
            headers: {"Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest"}
        }).then((function (e) {
            if (e.ok) if ("drawer" === window.theme.cartType && t) {
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
                const e = document.querySelector('[data-section-id="product-template"]');
                e && e.dispatchEvent(new CustomEvent("product:added", {
                    bubbles: !0,
                    detail: {variant: n[1], quantity: 1}
                }))
            } else setTimeout((function () {
                window.location.href = "/cart"
            }), 500)
        }))
    }))
}));
const youtubeVideos = [...document.querySelectorAll("[data-youtube]")];
youtubeVideos.forEach((function (e) {
    e.querySelector("[data-youtube-button]").addEventListener("click", (function () {
        const e = event.target.dataset.youtubeButton, t = event.target.parentNode,
            n = '<iframe width="100%" src="' + e + '?autoplay=1&showinfo=0&controls=1&rel=0&modestbranding=1" allow="autoplay;" frameborder="0" allowfullscreen></iframe>';
        t.style.display = "none", t.insertAdjacentHTML("beforebegin", n), t.parentNode.removeChild(t)
    }))
})), $(document).ready((function () {
    (function (e, t) {
        t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
        var n = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
        return n ? n[2] ? decodeURIComponent(n[2].replace(/\+/g, " ")) : "" : null
    })("customer_posted") && $(".modal--newsletter").attr("aria-hidden", "false");
    const e = document.getElementById("copiar-cupom");
    e && e.addEventListener("click", (function () {
        var e = document.getElementById("texto-cupom");
        navigator.clipboard && navigator.clipboard.writeText(e.innerText).then((function () {
        })).catch((function (e) {
        }))
    }))
}));
const miniCart = document.querySelector(".mini-cart");
let observer = null;

function handleMutation(e, t) {
    for (const t of e) if ("aria-hidden" === t.attributeName) {
        const e = "true" === t.target.getAttribute("aria-hidden");
        document.documentElement.style.overflow = e ? "auto" : "hidden"
    }
}

function startObserver() {
    (observer = new MutationObserver(handleMutation), observer.observe(miniCart, {
        attributes: !0,
        attributeFilter: ["aria-hidden"]
    }))
}

function stopObserver() {
    observer && (observer.disconnect(), observer = null)
}

window.addEventListener("load", startObserver), window.addEventListener("resize", (function () {
    startObserver()
}));

/* ==========================================
   Popup de produto complementar
========================================== */

(function () {
  if (window.mpmPopupComplementarIniciado) return;
  window.mpmPopupComplementarIniciado = true;

  function obterPopup() {
    return document.getElementById('popup-produto-complementar');
  }

  function abrirPopupComplementar() {
    var popup = obterPopup();

    if (!popup) return;

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('popup-complementar-aberto');
  }

  function fecharPopupComplementar() {
    var popup = obterPopup();

    if (!popup) return;

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-complementar-aberto');
  }

  function atualizarPrecoDaVariante() {
    var seletor = document.getElementById(
      'popup-complementar-variante'
    );

    var preco = document.getElementById(
      'popup-complementar-preco'
    );

    if (!seletor || !preco || seletor.tagName !== 'SELECT') {
      return;
    }

    var opcaoSelecionada =
      seletor.options[seletor.selectedIndex];

    if (opcaoSelecionada && opcaoSelecionada.dataset.preco) {
      preco.textContent = opcaoSelecionada.dataset.preco;
    }
  }

  function atualizarMiniCarrinho() {
  return fetch(
  window.Shopify.routes.root +
    'cart?view=mini-cart&_=' +
    Date.now(),
  {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    cache: 'no-store'
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Não foi possível atualizar o carrinho.');
      }

      return response.text();
    })
    .then(function (html) {
      var documentoAtualizado = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      var carrinhoNovo =
        documentoAtualizado.querySelector('.mini-cart');

      var carrinhoAtual =
        document.querySelector('.mini-cart');

      if (carrinhoNovo && carrinhoAtual) {
  carrinhoAtual.innerHTML = carrinhoNovo.innerHTML;
}
})
.then(function () {
  return fetch(
   window.Shopify.routes.root + 'cart.js?_=' + Date.now(),
    {
      cache: 'no-store'
    }
  );
})
.then(function (response) {
  if (!response.ok) {
    throw new Error('Não foi possível atualizar o contador.');
  }

  return response.json();
})
.then(function (carrinho) {
  var contadores = document.querySelectorAll(
    '.header__cart-count'
  );

  contadores.forEach(function (contador) {
    contador.textContent = carrinho.item_count;

    if (carrinho.item_count > 0) {
      contador.removeAttribute('hidden');
      contador.style.display = '';
    } else {
      contador.setAttribute('hidden', '');
      contador.style.display = 'none';
    }
  });
});
}

function abrirDrawerCarrinho() {
  var botoes = document.querySelectorAll(
    '.header__cart-toggle[data-action="open-drawer"][aria-controls="mini-cart"]'
  );

  var botaoVisivel = null;

  botoes.forEach(function (botao) {
    var estilo = window.getComputedStyle(botao);

    if (
      estilo.display !== 'none' &&
      estilo.visibility !== 'hidden' &&
      botao.offsetParent !== null
    ) {
      botaoVisivel = botao;
    }
  });

  if (botaoVisivel) {
    botaoVisivel.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

    return;
  }

  var miniCarrinho = document.getElementById('mini-cart');

  if (miniCarrinho) {
    miniCarrinho.setAttribute('aria-hidden', 'false');
  }
}

  function adicionarProdutoComplementar() {
    var seletor = document.getElementById(
      'popup-complementar-variante'
    );

    var botao = document.getElementById(
      'popup-complementar-adicionar'
    );

    if (!seletor || !botao) return;

    var varianteId = seletor.value;

    if (!varianteId) return;

    var textoOriginal = botao.textContent;

    botao.disabled = true;
    botao.textContent = 'Adicionando...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(varianteId),
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (erro) {
            throw new Error(
              erro.description ||
              'Não foi possível adicionar o produto.'
            );
          });
        }

        return response.json();
      })
      .then(function (dados) {
  botao.textContent = 'Adicionado ao carrinho';

  return atualizarMiniCarrinho()
.then(function () {

    document.dispatchEvent(
        new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
                scrollToTop: false
            }
        })
    );

    setTimeout(function () {
  fecharPopupComplementar();

  setTimeout(function () {
    abrirDrawerCarrinho();
  }, 150);

  botao.disabled = false;
  botao.textContent = textoOriginal;
}, 900);

});
})
.catch(function (erro) {
        console.error(
          'Erro ao adicionar produto complementar:',
          erro
        );

        botao.disabled = false;
        botao.textContent = textoOriginal;

        alert(
          erro.message ||
          'Não foi possível adicionar o produto. Tente novamente.'
        );
      });
  }

  document.addEventListener('product:added', function () {
    var popup = obterPopup();

    if (!popup) return;

    setTimeout(abrirPopupComplementar, 250);
  });

  document.addEventListener('click', function (evento) {
    var botaoFecharPopup = evento.target.closest(
  '[data-fechar-popup-complementar]'
);

if (botaoFecharPopup) {
  fecharPopupComplementar();

  setTimeout(function () {
    abrirDrawerCarrinho();
  }, 150);

  return;
}

    if (
      evento.target.closest(
        '#popup-complementar-adicionar'
      )
    ) {
      adicionarProdutoComplementar();
    }
  });

  document.addEventListener('change', function (evento) {
    if (
      evento.target.id === 'popup-complementar-variante'
    ) {
      atualizarPrecoDaVariante();
    }
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') {
      fecharPopupComplementar();
    }
  });
})();

/* Mi Mascota Mimada - Tradução da personalização */
(function () {
  function traduzirAvisos() {
    document.querySelectorAll('.cp-form').forEach(function (formulario) {
      var elementos = formulario.querySelectorAll('*');

      elementos.forEach(function (elemento) {
        Array.from(elemento.childNodes).forEach(function (node) {
          if (node.nodeType !== 3) return;

          var texto = node.nodeValue;

          if (!texto) return;

          var traduzido = texto
            .replace(/Preencha este campo/gi, 'Completa este campo')
            .replace(/Preencha os campos/gi, 'Completa los campos')
            .replace(/Personalización\s*::/gi, 'Personalización:');

          if (texto !== traduzido) {
            node.nodeValue = traduzido;
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    traduzirAvisos();

    var observador = new MutationObserver(function () {
      traduzirAvisos();
    });

    observador.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  });
})();





